import * as React from 'react';
import { Component } from 'react';
import './StatusBar.css';


//interface IProps {
//    ShowStatusBar: (type: 'Success' | 'Info' | 'Error', message: string, timeout?: number) => void
//}

interface IState {
    Message: string;
    Type: 'Success' | 'Info' | 'Error';
    Timeout?: number;
    Visible: boolean;
    ActionMessage?: string;
    Action?: () => void
}

export class StatusBarComponent extends Component<any, IState> {
    constructor(props) {
        super(props);

        this.state = {
            Message: '',
            Type: 'Info',
            Visible: false,
        }
    }

    public ShowStatusBar = (type: 'Success' | 'Info' | 'Error', message: string, timeout?: number, actionMessage?: string, action?: () => void) => {
        this.setState({
            Message: message,
            Type: type,
            Visible: true,
            Timeout: timeout,
            ActionMessage: actionMessage,
            Action: action
        });
    }

    public render() {
        if (this.state.Visible) {
            if (this.state.Timeout) {
                this.InitCloseTimeout(this.state.Timeout);
            }
            return (
                <div className="status-bar-component">
                    <div className={'message-container ' + this.state.Type.toLowerCase()}>
                        <div className="message-icon" />
                        <div className="message">
                            {this.state.Message}
                        </div>
                        <div
                            onClick={this.state.Action}
                            className="action-message">
                            {this.state.ActionMessage}
                        </div>
                        <div
                            onClick={this.Close}
                            className="close-icon" />
                    </div>
                </div>
            );
        } else {
            return null;
        }
    }

    private InitCloseTimeout = (timeout: number) => {
        setTimeout((t) => {
            t.setState({
                Visible: false
            });
        }, timeout, this);
    }

    private Close = (evt) => {
        this.setState({
            Visible: false
        });
    }
}


// WEBPACK FOOTER //
// ./src/controls/StatusBar.tsx